import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import Content from 'components/base/Content'
import Title from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'
import ResponsiveImage from 'components/base/ResponsiveImage'
import ProgressiveImage from 'components/base/ProgressiveImage'
import SectionRule from 'components/base/SectionRule/styles'
import Link from 'components/base/Link'

import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import AskQuestion from 'components/blocks/AskQuestion'
import RetailLounge from 'components/blocks/RetailLounge'

import LocationImage from 'assets/images/locations/eugene.webp'
import LocationImage64 from 'assets/images/locations/eugene-placeholder'
import HoursNotification from 'components/blocks/HoursNotification'

import { Location } from '../../../components/App/styles'

const ReatailLoungesEugene: React.FC = (): React.ReactElement => (
  <div>
    <HeaderMeta
      title='Insurance Agency In Eugene, OR | Insurance Lounge'
      description='Insurance Lounge is your one-stop-shop for insurance coverage in Eugene, Oregon. Shop Home, Auto, Life, Health & other insurance policies in seconds.'
      ogImg='/images/og-images/Eugene.webp'
    />
    <PageHero theme={PageHeroTheme.eugene} right={true} cta={true}>
      Insurance Agency In Eugene, OR
    </PageHero>
    <Content short={true} center={true} margined={true}>
      <Title level={2}>
        Insurance Lounge <br />Eugene, OR
      </Title>
      <Paragraph theme={ParagraphTheme.introLarge}>
        At Insurance Lounge in Eugene, OR, we focus on technology and innovation to make insurance shopping easy & convenient for you. Stop by to check out our unique store and experience managing your insurance in a whole new way!
      </Paragraph>
    </Content>
    <Content center={true} margined={true}>
      <ResponsiveImage width720={true}>
        <ProgressiveImage
          src={LocationImage}
          src2x={undefined}
          placeholder={LocationImage64}
          alt='Eugene Retail Store'
        />
      </ResponsiveImage>
    </Content>
    <Content center={true} margined={true}>
      <RetailLounge
        hoursWeekday='9:00am ⁠– 6:00pm'
        hoursWeekend='Closed'
        phone='800-211-8660'
      >
        <Location href='https://goo.gl/maps/UREEDguCKWZtkEGM9' target='_blank' rel='noopener noreferrer'>
          440 Coburg Rd
          <br />
          Suite 200
          <br />
          Eugene OR 97401
        </Location>
      </RetailLounge>
      <HoursNotification />
    </Content>
    <Content center={true} margined={true}>
      <iframe title='Map to Eugene, OR Insurance Lounge' src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2866.7756518220267!2d-123.07539478330669!3d44.067341079109305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54c0e1fc1da9b077%3A0x5a05477485ef0ced!2s440%20Coburg%20Rd%2C%20Eugene%2C%20OR%2097401!5e0!3m2!1sen!2sus!4v1677518395237!5m2!1sen!2sus' width='600' height='450' style={{ border:0 }} loading='lazy' referrerPolicy='no-referrer-when-downgrade' />
    </Content>
    <SectionRule />
    <Content center={true} short={true} margined={true}>
      <Title level={3}>The Insurance Lounge Difference</Title>
      <Paragraph>
        If you’re shopping for insurance for the first time,
        you probably have a lot of questions. There’s plenty to consider,
        and not every decision is easy. At Insurance Lounge, we understand that
        here’s no one-size-fits-all solution for insurance because everyone’s
        circumstances are different. We’re a no-commission insurance agency,
        so we’re more than happy to help you get exactly what you need. Learn
        how you can find comprehensive coverage in minutes.
      </Paragraph>
      <Title level={3}>
        Your Insurance, Your Way
      </Title>
      <Paragraph>
        Technology is at the forefront of our business, and that’s
        because we’re committed to providing you with the flexibility
        you need to shop and compare rates. Choose from over 100 carriers
        with the help of our online Insurance Concierges<sup>®</sup>.
        No matter how you prefer to purchase insurance, we can offer
        several ways to shop to make the process as painless as possible.
        You can find affordable coverage options that provide the protection
        you need by using our powerful quote comparison technology. Shop for
        policies online, over the phone, or stop by our location in Eugene,
        OR. Shop insurance coverage options for:&nbsp;
        <Link to='/products/homeowners-insurance'>Home</Link>,&nbsp;
        <Link to='/products/auto-insurance'>Auto</Link>,&nbsp;
        <Link to='/products/life-insurance'>Life</Link>,&nbsp;
        <Link to='/products/health-insurance'>Health</Link>,&nbsp;
        <Link to='/products/medicare-insurance'>Medicare</Link>,&nbsp;
        <Link to='/products/disability-insurance'>Disability</Link>,&nbsp;
        <Link to='/products/business-insurance'>Business</Link>,&nbsp;
        <Link to='/products/investments-retirement'>Retirement</Link>.
      </Paragraph>
      <Title level={3}>We’re Here to Help</Title>
      <Paragraph>
        At Insurance Lounge, our team is available to <Link to='/support'>answer all of your questions</Link>. We’re committed to providing the support you need to protect your family, property, and lifestyle. Whether you’re unsure of how much coverage is required or need help understanding deductibles, we’ll be available to help make this process more efficient and convenient. Our insurance agency has <Link to='/locations/storefronts'>locations throughout Oregon</Link> with friendly professionals who can assist you in a cool, comfortable environment. There’s no need to worry about fitting us into your schedule. We’re open seven days a week to make things easier for you. You deserve a better insurance experience, which is why we offer technology that allows you to shop for it your way. To get a quote, <Link to='/quote/new'>complete our form</Link> or call us at 800-211-8660.
      </Paragraph>
    </Content>
    <SectionRule />
    <AskQuestion title='We’re Here, When You Need Us'>
      Reach out and an Insurance Concierge<sup>®</sup> will get in touch!
    </AskQuestion>
  </div>
)

export default ReatailLoungesEugene
